import { motion } from 'framer-motion'
import Button from './Button'
import { duration } from '../lib/motion'
import { CALENDLY_URL } from '../data/config'

export default function FinalCTA({
  headline = 'Your next customer is already online.',
  subhead = "Let's talk about how your website should be working for you.",
  cta = { label: 'Send Us a Message', href: '#inquiry' },
  secondaryCta = { label: 'Prefer to talk first? Book a free strategy call', href: CALENDLY_URL, external: true },
  // Optional: when set, the primary CTA opens a popup (via onClick)
  // instead of following cta.href as an anchor/page link. Used on pages
  // where the destination is now a SideShift-style modal rather than a
  // scroll target — see Home/GetAWebsite in AppRoutes.jsx.
  onCtaClick,
}) {
  return (
    // py-32, not the sitewide py-24: this is the page's closing statement,
    // deliberately given more room to breathe before the footer, same
    // treatment as CaseStudy's "Key takeaway" section.
    <section className="py-32 border-t" style={{ borderColor: 'var(--border)' }}>
      <div className="container-bw text-center max-w-2xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: duration.base }}
          className="font-display text-4xl md:text-5xl leading-tight mb-6"
          style={{ color: 'var(--text-primary)' }}
        >
          {headline}
        </motion.h2>
        <p className="mb-10" style={{ color: 'var(--text-secondary)' }}>
          {subhead}
        </p>
        <Button
          href={onCtaClick ? undefined : cta.href}
          onClick={onCtaClick}
          target={cta.external ? '_blank' : undefined}
          rel={cta.external ? 'noreferrer' : undefined}
          variant="primary"
          ttqTrack
        >
          {cta.label}
        </Button>
        {secondaryCta && (
          <p className="mt-5 text-sm">
            <a
              href={secondaryCta.href}
              className="underline underline-offset-4"
              style={{ color: 'var(--text-muted)' }}
            >
              {secondaryCta.label}
            </a>
          </p>
        )}
      </div>
    </section>
  )
}
